import { useEffect, useRef } from 'preact/compat';

import { AppSettings } from '@/constants/app-settings';

type ChatbotElement = HTMLElement & {
  open: () => void;
  close: () => void;
  enableCampaign: () => void;
};

export function useChatbotLoader(chatId: string) {
  const chatbotRef = useRef<ChatbotElement | null>(null);

  useEffect(() => {
    if (!chatId) {
      return;
    }

    const loadChatbot = async () => {
      const existingScript = document.querySelector(
        `script[src="${AppSettings.chatbotScriptUrl}"]`,
      );

      if (!existingScript) {
        const script = document.createElement('script');
        script.src = AppSettings.chatbotScriptUrl;
        script.type = 'module';
        script.async = true;
        document.head.append(script);

        await new Promise((resolve, reject) => {
          script.addEventListener('load', resolve);
          script.addEventListener('error', reject);
        });
      }

      const existingChatbot = document.querySelector('kanbu-chatbot');

      if (existingChatbot) {
        existingChatbot.remove();
      }

      const chatbotElement = document.createElement('kanbu-chatbot');
      chatbotElement.setAttribute('chat', chatId);
      chatbotElement.setAttribute('campaign', '');
      document.body.append(chatbotElement);
      chatbotRef.current = chatbotElement as ChatbotElement;
    };

    loadChatbot();
  }, [chatId]);

  return chatbotRef;
}
